




















import Vue from 'vue'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  components: { BaseImage },
  props: {
    magazine: {
      type: Object,
      required: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.MAGAZINE_CARD
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    }
  }
})
